'use client';

import Image from 'next/image';
import Slider from 'react-slick';
import './styles.css';

const settings = {
  dots: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dotsClass: 'carousel-dots',
};

const imagesSourcesWithAlt = [
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc57d1f639e3.png`,
    alt: `Country & Town House`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc582f0cd2ea.png`,
    alt: 'Sainsbury`s Magazine',
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc583700a516.png`,
    alt: `The Sunday Times`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc5825c585ea.png`,
    alt: `Drift`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc58281943ef.png`,
    alt: 'The Gentleman`s Journal',
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc584c8ba1f9.png`,
    alt: `Globalista`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc5831b9f7b0.png`,
    alt: `The Guardian`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc58328e6425.png`,
    alt: `The Independent`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc5837b7f675.png`,
    alt: `The Telegraph`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc2e19231c9e.png`,
    alt: `Daily Mail`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc58382d4835.png`,
    alt: `The Times`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc582e51f8a4.png`,
    alt: `Red`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc5814ef396f.png`,
    alt: `Condè Nast Traveller`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc5816202c8b.png`,
    alt: `Cosmopolitan`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc5826bc4f2e.png`,
    alt: `Food & Travel Magazine`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc582b238f31.png`,
    alt: `Olive`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc582cb33161.png`,
    alt: `Primary Times`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc58361412f3.png`,
    alt: `The Irish Times`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc58397078cb.png`,
    alt: `The Luxury Channel`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc583ab907e9.png`,
    alt: `You & Your Wedding`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc585b571748.png`,
    alt: `I Love Sicilia`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/5dc5890d78ac4.png`,
    alt: `High50`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/60bf7b1e900cb.png`,
    alt: `Trip Savvy`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/60bf7fa9c211a.png`,
    alt: `Abode 2`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/60d9833d2a87e.png`,
    alt: `Ttg Media`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/60d983d6b3986.png`,
    alt: `Wedding Style`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/60d9ec82a385e.png`,
    alt: `Travel Dreams Magazine`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/6239e32c24a06.png`,
    alt: `Business Traveller`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/6239e42123bff.png`,
    alt: `The Sun`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/6239e66b0f4f1.png`,
    alt: `Carra Luxe`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/6239e6f34c844.png`,
    alt: `Glossy Magazine`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/634937d31f80f.png`,
    alt: `Fabric Magazine`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/634937f6d6025.png`,
    alt: `Money Week`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/6349381744dd1.png`,
    alt: `Absolutely London`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/635a54d23ae09.png`,
    alt: `DSCENE Online`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/637620bb29f68.png`,
    alt: `Absolutely Education`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/6376214da0fe1.png`,
    alt: `Kensington & Chelsea Review`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/63762166d5dfb.png`,
    alt: `Highlife`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/63d3a4279f3d5.png`,
    alt: `House of Coco`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/65a4fca486a42.png`,
    alt: `Glass`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/65ca038361144.png`,
    alt: `The Mail`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/65ca055f2a6a7.png`,
    alt: 'Women`s Health',
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/65ca0662e9f84.png`,
    alt: `Culture Trip`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/65ca076e5ef6e.png`,
    alt: `The Australian`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/65ca095c41f5f.png`,
    alt: `You Magazine`,
  },
  {
    src: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/medium_3-2/image/journal/a/668d1adcd690d.png`,
    alt: `House & Garden`,
  },
];

export default function PressArticlesList() {
  return (
    <div className="relative">
      <div className="hidden lg:flex flex-wrap mx-[-0.9375rem]">
        {imagesSourcesWithAlt.map((img) => (
          <div
            className="w-[calc(33.33333%-1.875rem)] desktop:w-[calc(25%-1.875rem)] mx-[0.9375rem] flex-[0_0_auto]"
            key={img.alt}>
            <div className="mb-12 text-center">
              <Image
                width={240}
                height={40}
                alt={img.alt}
                src={img.src}
                className="w-auto max-h-[40px] mx-auto mb-[20px] align-middle max-w-full h-auto"
              />
            </div>
          </div>
        ))}
      </div>
      <Slider
        className="about-us-press-articles-carousel w-[calc(100vw-1.875rem)] md:w-[calc(100vw-5rem)] mb-[30px] mx-0 lg:!hidden"
        {...settings}>
        {imagesSourcesWithAlt.map((img) => (
          <div key={img.alt} className="mb-8 text-center !block !w-none">
            <Image
              width={240}
              height={40}
              alt={img.alt}
              src={img.src}
              className="w-auto max-h-[40px] mx-auto mb-[20px] align-middle max-w-full h-auto"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}
